import React, { useState, useEffect } from "react";
import "./register.css";
import "../../App.css";
import { BsFillEyeFill } from "react-icons/bs";
import { BsFillEyeSlashFill } from "react-icons/bs";
import { BsEnvelope } from "react-icons/bs";
import { VscEdit } from "react-icons/vsc";
import { FiLock } from "react-icons/fi";
import { Link, useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";
import auth from "../../redux/actions/auth";
import {
  SCORE_PATH,
  LOGIN_PATH,
  REGISTER_PATH,
  ACCUEIL_PATH,
} from "../../routes/navigation/navigation_paths";
import { isValidEmail, isValidText } from "../../utils/form_control";
import { Oval } from "react-loader-spinner";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import personImg from "../../images/person-image.png";
import logoImg from "../../images/logo.png";
import bakeliImg from "../../images/training.png";

const Register = () => {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const [request, setRequest] = useState(false);
  const DEFAULT_MESSAGE = "Ce champ est obligatoire!";
  const [showPassword, setShowpassword] = useState(false);
  const [showPasswordConfirm, setShowpasswordConfirm] = useState(false);
  const {
    register,
    handleSubmit,
    formState: { errors },
    setError,
  } = useForm({
    defaultValues: {
      firstName: "",
      lastName: "",
      email: "",
      password: "",
      confirmPassword: "",
    },
  });

  useEffect(() => {
    if (request) {
      setTimeout(() => {
        setLoading(false);

        navigate(LOGIN_PATH);
      }, 5000);
    }
  }, [request]);

  const submit = (data) => {
    const { firstName, lastName, email, password, confirmPassword } = data;
    auth.signup(lastName, firstName, email, password, confirmPassword);
    setLoading(true);
    notify();
    setRequest(true);
  };

  /*useEffect(()=>{
        if(loading){
            navigate(LOGIN_PATH)
        }
    },[loading])*/
  const notify = () => {
    toast("Vous recevrez un email sur votre compte gmail");
  };

  const verificate = (data) => {
    let errorFields = [];
    if (!isValidText(data.firstName)) {
      errorFields.push({ field: "firstName", message: "Prenom invalid" });
    }
    if (!isValidText(data.lastName)) {
      errorFields.push({ field: "lastName", message: "Nom ivalid" });
    }
    if (!isValidEmail(data.email)) {
      errorFields.push({ field: "email", message: "Email non valid" });
    }
    if (data.password.length < 6) {
      errorFields.push({
        field: "password",
        message: "Mot de passe trop courte < 6",
      });
    }
    if (data.password !== data.confirmPassword) {
      errorFields.push({
        field: "confirmPassword",
        message:
          "Les deux mots de passe ne correspondent pas ou le compte existe déjà!",
      });
    }

    if (errorFields.length) {
      errorFields.map((err) => {
        let { field, message } = err;
        setError(field, { message: message });
      });
    } else {
      submit(data);
    }
  };

  return (
    <div className="min-h-screen md:h-[100vh] outline-2 flex flex-col items-center  justify-center bg-gradient-to-br from-teal-700 to-teal-500 overflow-hidden">
      <div className="text-white flex flex-col items-center lg:items-start">
        <div className="flex items-center gap-3 text-3xl font-bold">
          <img src={logoImg} alt="Logo" className="w-16" />
          <span>Bakeli Training</span>
        </div>
        {/* <p className="text-3xl text-center  ml-8 font-medium">
            Training the best
            <br />
            tech talent in Africa.
          </p> */}
      </div>
      {/* image & formulai */}
      <div className="flex flex-col lg:flex-row w-full max-w-6xl text-center items-center justify-center relative top-[20px]">
        <div className="hidden md:block lg:block">
          <img src={personImg} alt="Bakeli" className="max-w-lg" />
        </div>
        <div className="bg-white p-4 rounded-2xl   shadow-xl max-w-[400px] w-[100%] relative">
          <img src={logoImg} alt="Logo" className="mx-auto w-16" />
          <h3 className="text-center text-teal-700 text-1xl font-bold mb-6 mt-3 tracking-wide">
            CRÉATION DE COMPTE
          </h3>
          <form onSubmit={handleSubmit(verificate)} className="space-y-4 mt-1">
            <input
              type="text"
              placeholder="Prénom"
              {...register("firstName", { required: DEFAULT_MESSAGE })}
              className={`w-full px-4 py-2 border-2 rounded-md focus:outline-none focus:ring-2 focus:ring-teal-400 ${
                errors.firstName ? "border-red-500" : "border-teal-500"
              }`}
            />
            {errors.firstName && (
              <p className="text-red-500 text-sm">{errors.firstName.message}</p>
            )}

            <input
              type="text"
              placeholder="Nom"
              {...register("lastName", { required: DEFAULT_MESSAGE })}
              className={`w-full px-4 py-2 border-2 rounded-md focus:outline-none focus:ring-2 focus:ring-teal-400 ${
                errors.lastName ? "border-red-500" : "border-teal-500"
              }`}
            />
            {errors.lastName && (
              <p className="text-red-500 text-sm">{errors.lastName.message}</p>
            )}

            <input
              type="email"
              placeholder="Email"
              {...register("email", { required: DEFAULT_MESSAGE })}
              className={`w-full px-4 py-2 border-2 rounded-md focus:outline-none focus:ring-2 focus:ring-teal-400 ${
                errors.email ? "border-red-500" : "border-teal-500"
              }`}
            />
            {errors.email && (
              <p className="text-red-500 text-sm">{errors.email.message}</p>
            )}

            <div className="relative">
              <input
                type={showPassword ? "text" : "password"}
                placeholder="Mot de passe"
                {...register("password", { required: DEFAULT_MESSAGE })}
                className={`w-full px-4 py-2 border-2 rounded-md focus:outline-none focus:ring-2 focus:ring-teal-400 ${
                  errors.password ? "border-red-500" : "border-teal-500"
                }`}
              />
              <button
                type="button"
                onClick={() => setShowpassword(!showPassword)}
                className="absolute right-3 top-2 text-gray-500 text-lg"
              >
                {showPassword ? "🙈" : "👁️"}
              </button>
              {errors.password && (
                <p className="text-red-500 text-sm mt-1">
                  {errors.password.message}
                </p>
              )}
            </div>

            <div className="relative">
              <input
                type={showPasswordConfirm ? "text" : "password"}
                placeholder="Confirmer le mot de passe"
                {...register("confirmPassword", { required: DEFAULT_MESSAGE })}
                className={`w-full px-4 py-2 border-2 rounded-md focus:outline-none focus:ring-2 focus:ring-teal-400 ${
                  errors.confirmPassword ? "border-red-500" : "border-teal-500"
                }`}
              />
              <button
                type="button"
                onClick={() => setShowpasswordConfirm(!showPasswordConfirm)}
                className="absolute right-3 top-2 text-gray-500 text-lg"
              >
                {showPasswordConfirm ? "🙈" : "👁️"}
              </button>
              {errors.confirmPassword && (
                <p className="text-red-500 text-sm mt-1">
                  {errors.confirmPassword.message}
                </p>
              )}
            </div>

            <button
              type="submit"
              className="w-full mt-3 bg-[#FF9800] hover:bg-yellow-600 text-white font-bold py-2 rounded-full"
              disabled={loading}
            >
              {loading ? "Loading..." : "S'inscrire"}
            </button>

            {/* <div className="flex items-center gap-2 mt-2"> */}
            {/* <hr className="flex-grow border-gray-300" /> */}
            {/* <span className="text-gray-400 text-sm">OU</span> */}
            {/* <hr className="flex-grow border-gray-300" /> */}
            {/* </div> */}

            {/* <Link
              to={LOGIN_PATH}
              className="w-full inline-block mb-10 text-center no-underline border-2 border-teal-500 text-teal-600 font-semibold py-2 rounded-full hover:bg-teal-50"
            >
              <div className="flex justify-center items-center gap-2 ">
                <img src={bakeliImg} alt="Bakeli" className="w-6 h-6" />
                Se connecter avec Bakeli
              </div>
            </Link> */}

            <p className="text-center text-sm text-gray-600 mt-1">
              Vous avez déjà un compte ?{" "}
              <Link to={LOGIN_PATH} className="text-teal-600 font-semibold">
                Connectez-vous
              </Link>
            </p>
          </form>
          {loading && (
            <div className="absolute inset-0 flex justify-center items-center bg-white bg-opacity-75 rounded-2xl">
              <Oval
                height={40}
                width={40}
                color="#009688"
                wrapperStyle={{}}
                wrapperClass=""
                visible={true}
                ariaLabel="oval-loading"
                secondaryColor="#FFA000"
                strokeWidth={4}
                strokeWidthSecondary={2}
              />
            </div>
          )}
        </div>
      </div>
      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="colored"
      />
    </div>
  );
};

export default Register;
